import React from 'react';
import { EmblaOptionsType } from 'embla-carousel';
import useEmblaCarousel from 'embla-carousel-react';
import Autoplay from 'embla-carousel-autoplay';
import { Box } from '@chakra-ui/react';
import WheelGesturesPlugin from 'embla-carousel-wheel-gestures';
import './styles.css';

const OPTIONS: EmblaOptionsType = {
  dragFree: true,
};

export default function Desktop({ slides }: { slides: React.ReactNode[] }) {
  const [emblaRef] = useEmblaCarousel(OPTIONS, [
    Autoplay({ delay: 5000, stopOnInteraction: false }),
    WheelGesturesPlugin()
  ]);

  return (
    <Box
      mt={8}
      mb={12}
      className='embla'
      style={
        {
          '--slide-size': '404px',
          '--slide-spacing': '8px',
        } as React.CSSProperties
      }
    >
      <Box
        px={14}
        className='embla__viewport'
        ref={(el: HTMLDivElement | null) => {
          emblaRef(el);
        }}
      >
        <Box className='embla__container'>
          {slides}
        </Box>
      </Box>
    </Box>
  );
}
